import { Chip } from '@mui/material';
import { t } from 'i18next';

type Props = {
  isConfigured: boolean;
};

export const AccordionChip = ({ isConfigured }: Props) => {
  const chipProps = {
    'data-role': 'integration-chip',
    label: isConfigured ? t('integrationList.configured') : t('integrationList.notConfigured'),
    sx: { backgroundColor: isConfigured ? 'integrationChip.active' : 'integrationChip.inactive' },
  };

  return <Chip {...chipProps} />;
};
